<template>
	<apexchart
		:width="width"
		:height="height"
		:options="options"
		:series="parsedSeries"
	/>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "ReopenedRequests",
	props: {
		title: {
			type: String,
			default: "Solicitações Reabertas"
		},
		width: {
			type: [Number, String],
			default: "100%",
		},
		height: {
			type: [Number, String],
			default: "100%",
		},
		loading: {
			type: Boolean,
			default: false
		},
		data: {
			type: Object,
			default: () => ({ Pedidos: 0, Solicitações: 0 })
		}
	},
	components: {
		apexchart: VueApexCharts,
	},
	computed: {
		total() {
			return (this.data?.Pedidos ?? 0) + (this.data?.Solicitações ?? 0);
		},
		parsedSeries() {
			return [
				{ name: 'Pedidos', data: [this.data?.Pedidos ?? 0] },
				{ name: 'Solicitações', data: [this.data?.Solicitações ?? 0] }
			];
		},
		options() {
			const total = this.total;
			const pedidos = this.data?.Pedidos ?? 0;
			const solicitacoes = this.data?.Solicitações ?? 0;

			return {
				chart: {
					type: "bar",
					stacked: true,
					stackType: "normal",
					toolbar: { show: false },
					animations: {
						enabled: true,
						speed: 600,
					}
				},
				title: {
					text: this.title,
					align: "center",
					style: {
						fontSize: "14px",
						fontWeight: "bold",
					},
				},
				subtitle: {
					text: `Total: ${total}`,
					align: "center",
					style: {
						fontSize: "12px",
						color: "#6c757d"
					}
				},
				plotOptions: {
					bar: {
						horizontal: true,
						borderRadius: 4,
						borderRadiusWhenStacked: "last",
						dataLabels: {
							total: {
								enabled: false
							}
						}
					}
				},
				dataLabels: {
					enabled: true,
					formatter: (val, opts) => {
						const pct = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
						return `${val} (${pct}%)`;
					},
					style: {
						fontSize: "12px",
						fontWeight: "bold",
						colors: ["#fff"]
					},
					dropShadow: {
						enabled: true,
						blur: 2,
						opacity: 0.5
					}
				},
				colors: ["#e07b39", "#c0392b"],
				xaxis: {
					categories: ["Reabertas"],
					labels: { show: false },
					axisBorder: { show: false },
					axisTicks: { show: false },
					max: total > 0 ? total : 1
				},
				yaxis: {
					labels: { show: false }
				},
				legend: {
					show: true,
					position: "bottom",
					horizontalAlign: "center",
					formatter: (seriesName, opts) => {
						const val = opts.w.globals.series[opts.seriesIndex][0];
						const pct = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
						return `${seriesName}: ${val} (${pct}%)`;
					}
				},
				tooltip: {
					y: {
						formatter: (val) => {
							const pct = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
							return `${val} reaberta${val !== 1 ? 's' : ''} (${pct}%)`;
						}
					}
				},
				noData: {
					text: this.loading ? "Carregando..." : "Sem dados",
				},
				grid: {
					show: false
				}
			};
		}
	}
};
</script>

<style lang="scss" scoped>
</style>